import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";
import { OnboardingCtaComponent } from "@m19-board/containers/board-layout/board-sidebar/onboarding-cta.component";
import { toSignal } from "@angular/core/rxjs-interop";
import { OnboardingService } from "@m19-board/services/onboarding.service";
import { DatePipe } from "@angular/common";
import { AuthService } from "@front/m19-services";

@Component({
  selector: "app-onboarding-call-scheduled-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, OnboardingCtaComponent, DatePipe],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="promo"
      [title]="t('overlays.onboarding_call_scheduled_title')"
      [subtitle]="
        t('overlays.onboarding_call_scheduled_subtitle', {
          date: onboardingDate() | date: 'shortDate' : undefined : locale(),
          time: onboardingDate() | date: 'shortTime' : undefined : locale(),
        })
      "
    >
      <p overlayBody>{{ t("overlays.onboarding_call_scheduled_description_1") }}</p>
      <p overlayBody>{{ t("overlays.onboarding_call_scheduled_description_2") }}</p>
      <app-onboarding-cta overlayCta />
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingCallScheduledOverlayComponent {
  static readonly rule = OverlayRule.ONBOARDING_CALL_SCHEDULED;

  private readonly authService = inject(AuthService);
  private readonly onboardingService = inject(OnboardingService);

  protected readonly locale = toSignal(this.authService.userLocale$, { requireSync: true });

  onboardingDate = toSignal(this.onboardingService.onboardingCallDatetime$);
}
